<template>
  <div>
    <!--搜索-->
    <topSearchView  @topSearchParentReceive="topSearchParentReceiveFN"/>
      <div class="bottomView">
        <!--顶部的路径-->
        <div class="topPathView">
              <p>
                  <span>首页 > </span>
                  <span>{{ editionName }}></span>
                  <span v-for="(item ,index ) in showPathName" :key="index">
                      <span :class="index==showPathName.length-1?'blueSpan':''">{{ item }}</span>
                      <span v-if="index!=showPathName.length-1">></span>
                  </span>
              </p>
          </div> 
        <!--路径-->
        <div class="treeNav" v-if="false">
          <p>
            <span class="leftHome" @click="goHome">首页></span>
            <span class="ruleName">{{ ruleNameObj[propsDATA.path] }}</span>
          </p>
        </div>
  <div class="contentBox">
      <div class="leftBox tree_container">
        <el-tree
          class="show-tree"
          ref="eltree"
          :data="treeData"
          :props="defaultProps"
          :render-content="renderContent"
          :highlight-current="true"
          node-key="id"
          :default-expanded-keys="treeExpandData"
          :current-node-key="keyId"
          @node-click="handleNodeClick"
        >
          <!-- highlight-current 高亮显示 不让背景消失  如果想取消选中也可以在某个事件上为false就可以随着点击事件取消高亮 -->
        </el-tree>
      </div>
      <div class="rightBox">
        <!--标签中选中的分类-->
        <div class="showTreeName">
            <span>{{ rightShowTreeInfo.name }}</span>
            <span class="treeCount">({{ total }})</span>
        </div>
        <div class="crumbsBox" v-if="false">
          <span
            style="
              line-height: 24px;
              color: #003fa8;
              display: inline-block;
              vertical-align: top;
              font-weight: 700;
            "
            >标签：</span
          >
          <span>{{ ruleNameObj[propsDATA.path] }}></span>
          <span v-for="(item, index) in crumbslist" :key="index">
            <span :class="index == crumbslist.length-1?'lastSpan':''">{{ item }} </span>
            <span v-if="index != crumbslist.length-1">></span>
          </span>

          <el-breadcrumb
           v-if="false"
            separator-class="el-icon-arrow-right"
            style="display: inline-block; width: calc(100% - 50px)"
          >
            <el-breadcrumb-item
              class="myBread"
              v-for="(item, index) in crumbslist"
              :key="index"
              >{{ item }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <!-- 法规注释 -->
        <div class="fgzs" v-if="false">
          <div class="fgzsTitle">法规注释:</div>
          <div id="hidden" ref="hidden">
            <div
              class="fgzsContent"
              v-for="(item, index) in fgzsList"
              :key="index"
            >
              <p style="color: #003fa8; font-weight: 700">{{ item.title }}：</p>
              <p class="zsText" ref="fgzsText" v-html="item.content"></p>
            </div>
          </div>
          <div
            style="text-align: right; padding-right: 20px"
            v-show="mcBol == true"
          >
            <el-button
              type="text"
              class="expande-button"
              @click="expandeClick()"
              v-if="mcBtnBol == false"
              >点击展开</el-button
            >
            <el-button
              type="text"
              class="expande-button"
              @click="expandeClick()"
              v-if="mcBtnBol == true"
              >收起</el-button
            >
          </div>
        </div>
        <!--顶部的 几个分类选择-->
        <div class="topType">
          <div class="topTypeListBox">
            <!-- <div 
              v-for="(item,index) in rightTopTypeList" 
              :key="index" 
              class="topTypeList"
              @click="rightTopTypeClick(item,index)"
              :class="rightTopTypeIndex == index ?'topTypeListCheck':''">
              {{ item.name }}
            </div> -->
            <div 
              v-for="(item,index) in rightTopTypeList" 
              :key="index" 
              class="topTypeListNew"
              @click="rightTopTypeClick(item,index)"
              :class="rightTopTypeIndex == index ?'topTypeListCheck':''">
              {{ item.name }}
            </div>
          </div>
          <div v-if="rightTopTypeIndex==1" class="zcgdChildType">
            <div class="zcjdTypeChildListBox">
              <div 
                class="zcjdTypeChildList" 
                :class="zcjdChildTypeIndex == index?'zcjdTypeChildListCheck':''"
                v-for="(item,index) in zcjdTypeChildList" 
                @click="zcjdChildListClick(item,index)"
                :key="index">{{item.name}}</div>
            </div>
          </div>
          <!-- <div class="zcgdChildType" v-if="rightTopTypeIndex==0"> -->
          <div class="zcgdChildType" v-if="false">
            <div class="zcgdChildListBox">
              <div 
                v-for="(item,index) in zcgdChildType" 
                :key="index" 
                class="zcgdChildList"
                @click="zcgdChildListClick(item,index)"
                :class="zcgdChildTypeIndex == index ?'zcgdChildListCheck':''">
                {{ item.name }}
              </div>
            </div>
            <div class="zcjdChildType" v-if="zcgdChildTypeIndex == 1">
              <div class="jianjiao"></div>
              <div 
                v-for="(item,index) in zcjdChildType" 
                :key="index" 
                class="zcjdChildTypeList"
                :id="'zcjdList' + index"
                @click="zcjdChildListClick(item,index)"
                :class="zcjdChildTypeIndex == index ?'zcjdChildListCheck':''">
                <p>{{ item.name }}</p>
                <!-- <div class="sanjiaoxing" v-if="zcjdChildTypeIndex == index"></div> -->
              </div>
            </div>
          </div>
          <!--数据条数-->
          <div class="getDataTotal" :class="rightTopTypeIndex==0?'getDataTotalW':''" v-if="total!=0">
            <p>
              <span>共有</span>
              <span class="totalRed">{{ total }}条</span>
              <span>{{ TagsName }}</span>
            </p>
          </div>
        </div>

        <div class="tags" v-if="false">
          <div style="width: calc(100% - 40px); margin: 0 20px">
            <div
              style="
                padding: 23px 0px 25px;
                line-height: 100px;
                display: flex;
                justify-content: space-between;
                background: #ffffff;
              "
            >
              <div
                class="tag"
                v-for="(item, index) in tagsList"
                :key="index"
                @click="oneTagFun(item.id, index)"
                :class="{ tagTrue: oneTagNum == item.id }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="fgyjList">
            <div
              style="
                width: 100%;
                background: #eef8ff;
                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
                margin-bottom: 10px;
              "
            >
              <div
                class="fgTags"
                style="padding-top: 18px"
                v-if="twoTags != false"
              >
                <div
                  class="fgTag"
                  v-for="(item, index) in twoTags"
                  :key="index"
                  :class="{ fgTagTrue: twoTagNum == item.id }"
                  @click="twoTagFun(item.id, index, item)"
                >
                  {{ item.name }}
                </div>
              </div>
              <div
                style="
                  padding: 10px 20px 20px;
                  line-height: 24px;
                  font-size: 16px;
                "
                v-if="oneTagNum != 5880"
              >
                <span v-if="list.length == 0">没有相应匹配的内容</span>
                <span v-else
                  >共有<span style="color: #f00">{{ total }}条</span
                  >{{ TagsName }}</span
                >
              </div>
              <div class="fgbqNum" v-else>
                <p
                  style="line-height: 30px; padding-bottom: 30px"
                  v-if="fgbqTagTotal != 0"
                >
                  这项分类中有<span style="color: #ff0000">{{
                    fgbqTagTotal
                  }}</span
                  >条法规条款发生过变迁，涉及以下相关的法规条数：
                </p>
                <p style="line-height: 30px; padding: 11px 0" v-else>
                  <span>没有相应匹配的内容</span>
                </p>
                <div
                  class="fgbqTags"
                  :class="{ act: fgbqTagNum === item.name }"
                  v-for="(item, index) in fgbqTagList"
                  @click="fgbqTagFun(item.name)"
                >
                  <div class="fgbqTagTitle">{{ item.name }}</div>
                  <div class="fgbqTagSize">
                    <span>{{ item.num }}条</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 政策规定 ———— 办税实务操作  -->
        <!-- <div class="TagsBox">
          <div class="oneTagsBox">
            <span v-for="(item,index) in tagsList" :key="index"  :class="{'indexTag':oneTagNum == item.id,'indexBefore':oneTagNum - 1 == item.id}" @click="oneTagFun(item.id,index)"><span class="RBor">{{item.name}}</span></span>
          </div>
          <div class="twoTagsBox">
            <div style="padding:0 20px;">
              <span v-for="(item,index) in twoTags" :key="index" class="twoTags" :class="{'twoIndex':twoTagNum == item.id}" @click="twoTagFun(item.id,index,item)">{{item.name}}</span>
            </div>
            
            <div class="threeTagsBox" v-if="threeTags">
              <span class="threeTags" :class="{'threeIndex':threeTagNum == item.id}" v-for="(item,index) in threeTags" :key="index" @click="threeTagFun(item.id,index)">{{item.name}}</span>
            </div>
            <div class="jdTreeBox" v-if="oneTagNum == 5878" style="background: #EEF8FF;padding:10px 20px;">
              <div
                  v-if="twoTagNum == 5915"
                    class="jdTags fgTagTrue"
                    :class="{
                      fgTagTrue: dqList.includes(item.name),
                      fgTagTrue2: item.id == jdTagsId,
                    }"
                    v-for="item in jdTagsList"
                    :key="item.id"
                    @click="dfJdFun(item.id)"
                  >
                    {{ item.name }}
                  </div>
              <div
                    v-if="twoTagNum == 5916"
                    class="jdTags fgTagTrue"
                    :class="{
                      fgTagTrue: dqList.includes(item.name),
                      fgTagTrue2: item.id == jdTagsId,
                    }"
                    v-for="item in szTagsList"
                    :key="item.id"
                    @click="dfJdFun(item.id)"
                  >
                    {{ item.name }}
              </div>
            </div>
            <div class="twoTagsTotal" style="padding:20px 20px 0;">共有<span style="color:#FF0000">{{total}}条</span>{{TagsName}}</div>
          </div>
        </div> -->
        <!-- 列表 -->
        <!--答疑列表  rightTopTypeIndex == 1-->
        <div v-if="rightTopTypeIndex == 2">
          <dayiView @sendTotal="sendTotalFN" :sendData="{tagIds:tagIds}" />
        </div>
        <div v-if="rightTopTypeIndex == 0||rightTopTypeIndex == 1" class="zsgdListBox">
          <div v-if="total > 0">
            <!-- 基本政策类型列表 -->
            <div
              class="zsgdList"
              v-for="(item, index) in list"
              v-if="oneTagNum == 5873"
            >
              <div v-if="item.modelId != 'fagui'">
                <div class="zsgdListLeft">
                  <div class="blueLabel">
                    <span
                      >第<!-- {{ TagsName }} -->{{
                        index + 1 + (page - 1) * 10
                      }}条</span
                    >
                  </div>
                  <span
                    class="pInline"
                    style="line-height: 32px"
                    v-html="textFil(item.textHtml)"
                  ></span>
                </div>
                <div
                  class="zsgdListRight"
                  @click="contentJump(item.parent.id, item.id)"
                >
                  <div class="zsgdRightTitle">
                    政策标题：<span style="color: #0000ff">{{
                      item.parent.title
                    }}</span>
                  </div>
                  <div class="zsgdRightType" v-if="item.modelId == 'p'">
                    该法规条款效力范围：{{
                      statusType[item.extend.state_dictionary]
                    }}
                  </div>
                  <div class="zsgdRightType" v-else>
                    该法规条款效力范围：{{ item.parent.xlfwName }}
                  </div>
                  <div class="zsgdRightDate" v-if="item.parent">
                    发文日期：{{ item.parent.publishDate | formatDate }}
                  </div>
                </div>
              </div>
              <div
                class="ddfglb"
                v-else
                style="padding: 0 20px; background: #f5f5f5; margin: 20px 0"
              >
                <div
                  style="
                    width: 40px;
                    height: 30px;
                    border-radius: 0px 0px 15px 0px;
                    background: #003fa8;
                    text-align: center;
                    transform: translateX(-20px);
                  "
                >
                  <span
                    style="
                      font-size: 16px;
                      font-weight: bold;
                      line-height: 30px;
                      color: #ffffff;
                    "
                    >{{ index + 1 + (page - 1) * 10 }}</span
                  >
                </div>
                <div class="source" @click="contentJump(item.id)">
                  政策标题：
                  <span
                    style="
                      font-size: 14px;
                      font-weight: normal;
                      line-height: 32px;
                      letter-spacing: 0em;
                      color: #0000ff;
                    "
                    v-html="item.title"
                  >
                  </span>
                </div>
                <div class="timeBox">
                  <span>效力范围：{{ item.xlfwName }}</span>
                  <span
                    class="time"
                    v-if="item.parentList && item.parentList.length != 0"
                    >发文日期：{{
                      item.parentList[0].publishDateTime | formatDate
                    }}</span
                  >
                </div>
              </div>
            </div>
            <!-- 解读类型列表 -->
            <div
              class="zsgdList"
              v-for="(item, index) in list"
              v-if="oneTagNum == 5883"
            >
              <div class="zsgdListLeft">
                <div class="blueLabel">
                  <span
                    >第<!-- {{ TagsName }} -->{{
                      index + 1 + (page - 1) * 10
                    }}条</span
                  >
                </div>
                <span
                  class="pInline"
                  style="line-height: 32px"
                  v-html="textFil(item.textHtml)"
                ></span>
              </div>
              <div
                class="zsgdListRight"
                @click="contentJump(item.parent.id, item.id)"
              >
                <div class="zsgdRightTitle">
                  政策标题：<span style="color: #0000ff">{{
                    item.parent.title
                  }}</span>
                </div>
                <div class="zsgdRightType">
                  该法规条款效力范围：{{
                    statusType[item.parent.extend.state_dictionary]
                  }}
                </div>
                <div class="zsgdRightDate" v-if="item.parent">
                  发文日期：{{ item.parent.publishDate | formatDate }}
                </div>
              </div>
            </div>
            <!-- 政策变迁列表 -->
            <div v-if="oneTagNum == 5880">
              <div class="fgbqList">
                <el-empty
                  v-if="total == 0"
                  :image="noneBg"
                  description=" "
                ></el-empty>
                <div
                  class="fgbqTypeList"
                  v-for="(item, index) in list"
                  :key="item.id"
                >
                  <div class="type" v-if="item">
                    <div style="width: 140px; display: inline-block">
                      <div class="typeNum" :id="'fgbq' + index">
                        变迁条款{{ index + 1 + (page - 1) * 10 }}
                      </div>
                    </div>
                    <div
                      style="display: inline-block; width: calc(100% - 160px)"
                    >
                      <div class="typeIntro">
                        主要变迁内容：<span style="color: #ff0000">{{
                          item.author
                        }}</span>
                        现行有效法规{{ item | isValidTrue }}条，过时失效法规{{
                          item | isValidFalse
                        }}条。
                      </div>
                    </div>
                  </div>
                  <div class="list">
                    <div
                      class="title"
                      :class="{
                        titleFalse: item.extend.state_dictionary !== '1',
                      }"
                    >
                      <span v-if="item.extend.state_dictionary == '1'"
                        >1.现行有效法规</span
                      >
                      <span v-else>1.过时失效法规</span>
                    </div>
                    <div
                      style="
                        padding: 0 20px;
                        background: #f5f5f5;
                        margin: 20px 0;
                      "
                    >
                      <div
                        class="source"
                        @click="contentJump(item.parent.id, item.id)"
                      >
                        政策标题：
                        <span
                          style="
                            font-size: 14px;
                            font-weight: normal;
                            line-height: 32px;
                            letter-spacing: 0em;
                            color: #0000ff;
                          "
                        >
                          {{ item.parent.title }}
                        </span>
                      </div>
                      <div class="timeBox">
                        <span
                          >该法规条款效力范围：{{
                            statusType[item.extend.state_dictionary]
                          }}</span
                        >
                        <span class="time"
                          >发文日期：{{ item.publishDate }}</span
                        >
                      </div>
                    </div>
                    <div class="content">
                      <span style="color: rgb(0, 63, 168); font-weight: 700"
                        >基本规定：</span
                      >
                      <span v-html="item.textHtml"></span>
                    </div>
                    <!-- <div class="more" @click="contentJump(item.faguiId,item.id)">
                    <span>详见原文</span>
                  </div> -->
                  </div>
                  <div class="list" v-for="(items, index) in item.childs">
                    <div
                      class="title"
                      :class="{
                        titleFalse: items.extend.isValid_boolean != 'true',
                      }"
                    >
                      <!-- <span v-if="items.isValid == false">过时失效法规{{ index + 1 }}</span>
                    <span v-else>现行有效法规{{ index + 1 }}</span> -->
                      <span v-if="items.extend.isValid_boolean == 'true'"
                        >{{ index + 2 }}.现行有效法规</span
                      >
                      <span v-else>{{ index + 2 }}.过时失效法规</span>
                    </div>
                    <div
                      style="
                        padding: 0 20px;
                        background: #f5f5f5;
                        margin: 20px 0;
                      "
                      v-if="items.relationContent"
                    >
                      <div
                        class="source"
                        @click="
                          contentJump(items.extend.faguiId_content, items.id)
                        "
                      >
                        政策标题：
                        <span
                          style="
                            font-size: 14px;
                            font-weight: normal;
                            line-height: 32px;
                            letter-spacing: 0em;
                            color: #0000ff;
                          "
                        >
                          {{ items.relationContent.title }}
                        </span>
                      </div>
                      <div class="timeBox">
                        <span
                          >该法规条款效力范围：<span
                            v-if="items.extend.isValid_boolean == 'true'"
                            >有效</span
                          >
                          <span v-else>失效</span></span
                        >
                        <span class="time"
                          >发文日期：{{
                            items.relationContent.publishDate
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="content">
                      <span style="color: rgb(0, 63, 168); font-weight: 700"
                        >基本规定：</span
                      >
                      <span v-html="items.textHtml"></span>
                    </div>
                    <!-- <div class="more" @click="contentJump(items.faguiId,items.id)">
                    <span>详见原文</span>
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 相关观点类型列表 -->
            <div v-if="oneTagNum == 5885">
              <div class="zsgdList" v-for="(item, index) in list" :key="index">
                <div class="zsgdListLeft">
                  <p style="color: #3d3d3d" @click="contentJump(item.id)">
                    <span style="color: #0000ff; line-height: 32px"
                      >{{ index + 1 + (page - 1) * 10 }}.</span
                    ><span v-html="item.title"></span>
                  </p>
                  <div
                    style="
                      margin-top: 20px;
                      padding: 8px 0;
                      background: #f5f5f5;
                      display: flex;
                      color: #003fa8;
                    "
                  >
                    <span
                      style="
                        flex: 1;
                        display: inline-block;
                        line-height: 24px;
                        text-align: left;
                        padding-left: 20px;
                      "
                      >来源：</span
                    >
                    <span
                      style="
                        flex: 4;
                        display: inline-block;
                        line-height: 24px;
                        text-align: left;
                      "
                      >{{ item.source }}</span
                    >
                    <span
                      style="
                        flex: 1;
                        display: inline-block;
                        line-height: 24px;
                        text-align: left;
                      "
                      >作者：</span
                    >
                    <span
                      style="
                        flex: 4;
                        display: inline-block;
                        line-height: 24px;
                        text-align: left;
                      "
                      >{{ item.author }}</span
                    >
                    <span
                      style="
                        flex: 2;
                        display: inline-block;
                        line-height: 24px;
                        text-align: left;
                      "
                      >发文日期：</span
                    >
                    <span
                      style="
                        flex: 3;
                        display: inline-block;
                        line-height: 24px;
                        text-align: left;
                      "
                      >{{ item.publishDate }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            
            <!-- <el-empty
              :image="noneBg"
              description="没有相应匹配的内容"
            ></el-empty> -->
          </div>
          <!-- 分页 -->
          <div style="background: #fff; text-align: center; padding: 10px" v-if="total > 0">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="this.size"
              layout="total, prev, pager, next,jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>

        <!--数据展示-->
        <div v-if="markdownContent!==''" class="notData">
            <NnitMarkdown
            id="notData"
            :source="markdownContent"
            :showLine="false"
          />
        </div> 
        <!--  -->
      </div>
    </div>
  </div>
  </div>
</template>

<script>

  import topSearchView from '@/components/topSearch.vue'
  import dayiView from '../../zsgView/dayi/index.vue'
  import NnitMarkdown from '@/components/unit-markdown/unit-markdown.vue'
  import { fetchEventSource } from '@microsoft/fetch-event-source'


  //引入列表
  import { ruleNameObj,topSevenType } from '@/config/ruleList.js'

  //跳转地址
// import {
// 	baseURL,
// 	zsdyURL
// } from '@/utils/config'
const baseURL = 'https://xcx.youzics.com/'

//引入文件
//import TextOverflow from './components/fgzs.vue'
import listJs from '@/config/index.js'

import noneBg from '@/assets/images/zsgView/noneBg.png'
import blueAdd from '@/assets/images/zsgView/blueAdd.png'
import bluesubtract from '@/assets/images/zsgView/bluesubtract.png'
import add from '@/assets/images/zsgView/add.png'
import subtract from '@/assets/images/zsgView/subtract.png'
import blueTrue from '@/assets/images/zsgView/blueTrue.png'
import blank from '@/assets/images/zsgView/blank.png'
import {
  tagTreeCache,
  dataSearch,
  cmsDataSearchFgbqTypeList,
  cmsDataSearchTagIsHave,
  cmsDataGetTagNames,
  getDaYiData,
  cmsDictionaryDataList,
  categoryCategoryTree,
  zsgSearch,
} from '@/api/importZSG/api'

//新加的检索框的引入数据
import linkJS from '@/config/linkindex'
const searchLink = linkJS[process.env.NODE_ENV]['indexUrl']
const tuLink = linkJS[process.env.NODE_ENV]['tuUrl']
const dyLink = linkJS[process.env.NODE_ENV]['dyUrl']

export default {
  name: 'lamlog',
  components: {
    //TextOverflow,
    topSearchView,
    NnitMarkdown,
    dayiView
  },
  data() {
    return {
      //搜索版本名
      editionName:'行业版',
      //展示的分类名们
      showPathName:['生活服务业'],
      //右侧展示的选中的名字和数量
      rightShowTreeInfo:{
          name:'生活服务业',
          count:0,
      },
      //传递进来的数据
      propsDATA:null,
      ruleNameObj:ruleNameObj,
      //右侧分类的选中 
      rightTopTypeIndex:0,
      rightTopTypeList:topSevenType,
      //政策规定下方的子级
      zcgdChildType:topSevenType[0].childs,
      //政策规定下方的子级的选中
      zcgdChildTypeIndex:0,
      //政策解读下方的子级
      //zcjdChildType:topSevenType[0].childs[1].childs,
      zcjdChildType:[],
      //政策解读下方的子级的选中
      zcjdChildTypeIndex:0,
      zcjdTypeChildList:[],
      //答疑列表
      dayiList:[],
      //大模型相关
      markdownContent: '',
      ctrl: null,
      sseshow: false,
      eventSource: null,
      objdata:{},
      scrollTop: 0, // 切换是文章列表滚动到顶部
      old: {
        scrollTop: 0,
      },

      text: '增值税纳税人,是指税法规定负有缴纳增值税义务的单位和个人,在我国境内销售、进口货物或者提供加工、修理、修配劳务以及应税服务的单位和个人,以上所述均视为增值税纳税人税法规定负有缴纳增值税义务的单位和个人,在我国境内销售、进口货物或者提供加工、修理、修配劳务以及应税服务的单位和个人,以上所述均视为增值税纳税人',
      expanded: false,
      aaa: '',
      // 特殊判断查法规的标签
      abc: [
        // 6564395, 6564396, 6564397, 6567776, 6567783, 6567784, 6567791, 6567792,
        // 6567793, 6567794, 6567795, 6592084, 6621705, 6621710, 6621742, 6627581,
        // 6564399, 6564414, 6564429,
      ],
      // 特殊判断隐藏的标签
      abcd: [],
      xgjdText: '税务总局解读',
      dqList: ['全部'],

      jdTagsId: '0',
      jdTagsList: [],
      szTagsList: [],
      fgbqTagNum: 0,
      fgbqTagList: [],
      fgbqTagTotal: 0,
      statusType: ['', '有效', '失效', '部分失效', '-', '特定时间失效'],
      rootId: '',
      name: '',
      noneBg: noneBg,
      oneTags: [
        {
          name: '政策规定',
          type: '0',
        },
        {
          name: '政策运用',
          type: '1',
        },
        {
          name: '涉税会计处理实务',
          type: '2',
        },
        {
          name: '行业涉税实务',
          type: '3',
        },
        {
          name: '经营环节涉税实务',
          type: '4',
        },
        {
          name: '办税实务操作',
          type: '5',
        },
      ],
      twoTags: [
        {
          name: '基本政策',
          type: '0',
        },
        {
          name: '政策变迁',
          type: '1',
        },
        {
          name: '相关国家政策',
          type: '2',
        },
        {
          name: '相关地方政策',
          type: '3',
        },
      ],
      threeTags: [],
      tagData: [
        {
          name: '名词解释',
          type: '0',
        },
        {
          name: '法规依据',
          type: '1',
        },
        {
          name: '相关解读',
          type: '2',
        },
        {
          name: '法规变迁',
          type: '3',
        },
        {
          name: '对应答疑',
          type: '4',
        },
        {
          name: '相关观点',
          type: '5',
        },
      ],
      treeData: [],
      defaultProps: {
        //el-tree 树结构默认渲染的字段
        children: 'childs',
        label: function (a, b) {
          return a.attribute.extend.name
        },
        isLeaf: 'isLeaf', //isLeaf在tree组件里面算是判断有没有子集 相当于可以控制三角显示▶️
      },
      crumbslist: [],
      tagNum: '1',
      list: [],
      treeExpandData: [], //自己定义的用于接收tree树id的数组
      keyId: '',
      page: 1,
      size: 10,
      tagTreeId: '',
      fgbq: {
        size: 0,
        list: [],
        text: '',
      },
      loading: '',
      total: 1,
      currentPage1: 1,
      isTopTag: true,
      mcBol: false,
      mcBtnBol: false,
      fgzsList: [],
      oneTagNum: 5873,
      twoTagNum: 0,
      threeTagNum: '',
      tagsList: [],
      fgzsTreeId: '',
      TagsName: '基本政策',
      tagIds: '',
      // 用户信息
      user: '',
    }
  },
  filters: {
    formatDate(time) {
      if (!time) {
        return time
      }
      if (typeof time == 'number') {
        try {
          var date = new Date(time)
          var Y = date.getFullYear() + '-'
          var M =
            (date.getMonth() + 1 < 10
              ? '0' + (date.getMonth() + 1)
              : date.getMonth() + 1) + '-'
          var D = date.getDate() + ' '
          return Y + M + D
        } catch (e) {
          console.log(time)
          return time
        }
      } else {
        return time.slice(0, 10)
      }
    },
    isValidTrue(v) {
      console.log(v)
      let Num = 0
      if (v.extend.state_dictionary === '1') {
        Num++
      }
      if (v.childs) {
        v.childs.forEach((element) => {
          if (element.extend.isValid_boolean == 'true') {
            Num++
          }
        })
      }
      return Num
    },
    isValidFalse(v) {
      console.log(v)
      let Num = 0
      if (v.extend.state_dictionary !== '1') {
        Num++
      }
      if (v.childs) {
        v.childs.forEach((element) => {
          if (element.extend.isValid_boolean != 'true') {
            Num++
          }
        })
      }

      return Num
    },
  },
  created() {
      //console.log(this.$props.sendZsgObj)
      console.log(this.$route.query)
      //console.log(this.$props.sendZsgObj)
      //this.propsDATA = this.$props.sendZsgObj
      this.propsDATA = this.$route.query
    //console.log('测试用的呀')
    // 版本更新不需要该接口了
    // this.cmsDictionaryDataList("zsgSearchFG");
    this.abcd = listJs.clearArr
    // this.cmsDictionaryDataList("zsgHideTag");
    this.categoryCategoryTree()
    // console.log(this.abcd);
    /* 
            常用 6557331 
            税种 6558575 
            规费基金 6561976 
            行业常用6562083 
            企业经营行为6563043 
            税干常用6563911 
            会计常用6564398 
            税收优惠6564533
            进出口 6565603
            */
    //console.log(this.$route);
    // switch (this.propsDATA.path) {
    //   case 'cyywgz':
    //     this.rootId = '5925'
    //     break

    //   case 'szywgz':
    //     this.rootId = '7683'
    //     break
    //   case 'gfjjywgz':
    //     this.rootId = '11878'
    //     break
    //   case 'qyccssgz':
    //     this.rootId = '16864'
    //     break
    //   case 'sgywgz':
    //     this.rootId = '18767'
    //     break
    //   case 'ssyhywgz':
    //     this.rootId = '19943'
    //     break
    //   case 'jckssgz':
    //     this.rootId = '21043'
    //     break
    //   case 'fxkzgz':
    //     this.rootId = '19360'
    //     break
    // }

    this.rootId = '12017'


    //判断是否是从官网首页跳转进来的 liyanze分支增加
    if (this.propsDATA.from == 'gw') {
      if (this.propsDATA.pId) {
        //将id转为数字类型
        let numberStr = Number(this.propsDATA.pId)
        //默认展开
        this.treeExpandData = [numberStr]
        this.tagTreeId = this.propsDATA.tagTreeId
        this.tagNum = this.propsDATA.searchType
      } else {
        //this.provincialCenterId = 6557381;
        this.tagTreeId = this.propsDATA.tagTreeId
        this.tagNum = this.propsDATA.searchType
      }
      if (this.propsDATA.special) {
        this.aaa = '6'
      }
      this.tagTree('6')
    } else {
      this.tagTree()
    }
    // 获取tree
    this.loading = this.$loading({
      lock: true,
      text: '拼命加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    // 版本更新不需要该接口了
    // this.dqFun();
    // this.dqFun(true);
  },
  mounted() {
      console.log(this.$route.query)
    let that = this
    setTimeout(function () {
      that.getLeftTreeHeight()
    }, 700)
  },
  destroyed() {
    this.ctrl.abort()
    this.sseshow = false
    this.markdownContent = ''
    this.eventSource = null
    this.ctrl = null
  },
  methods: {
      //搜索框 搜索按钮的点击 -- 子组件传递
      topSearchParentReceiveFN(data){
        //获取点击输入框时传递的一些参数
        console.log(data)
        this.searchSend = data
        this.searchSend.searchType = 0
        
        //传递给树的数据 重置
        //this.sendDataTreeLeft = []
        //获取左侧的树数据
        //this.getLeftTreeDataFN();

        //获取右侧列表中的数据:sendData="sendListData" :sendSearchData="searchSend"
        //this.$refs.jcalListView.getStart(this.sendListData,this.searchSend)
      },
    //回首页
    goHome(){
      console.log('看后续是否需求回首页')
    },
    //右侧顶部几个分类的点击
    rightTopTypeClick(item,index){

      this.markdownContent = ''
      this.total = 0;
      if (this.eventSource) {
        this.ctrl.abort()
        this.sseshow = false
        this.markdownContent = ''
        this.eventSource = null
        this.ctrl = null
      }

      if(this.rightTopTypeIndex == index){
        return
      }
      this.rightTopTypeIndex = index;
      if(index == 0){
        this.page = 1;
        this.total = 0;
        this.threeTags = [];
        this.twoTagNum = item.childs[0].id;
        this.TagsName = '基本政策';
        this.zcgdChildTypeIndex = 0;
        //默认调用 基本政策 数据
        this.zsgSearch()
      }else if(index == 1){
        this.page = 1;
        this.total = 0;

        this.zcjdTypeChildList = item.childs
        this.zcjdChildTypeIndex = 0
        this.twoTags = true;
        this.TagsName = '税务总局解读';
        //默认调用 税务总局解读 数据
        this.zcjdChildListClick(item.childs[0],0)

        //展示答疑子模块
      }else if(index == 2){
        this.TagsName = item.name
        this.page = 1;
        this.total = 0;
        //展示答疑子模块
      }else{
        console.log(item)
        this.getSeeAsk(item.code)
      }
      
      //调用那个什么勾八接口
      //this.fetchSSE('ruleLaw')
    },
    //政策规定下的几个子分类的点击
    zcgdChildListClick(item,index){
      this.zcgdChildTypeIndex = index;
      this.TagsName = item.name
      this.markdownContent = ''
      this.total = 0
      if (this.eventSource) {
        this.ctrl.abort()
        this.sseshow = false
        this.markdownContent = ''
        this.eventSource = null
        this.ctrl = null
      }
      //debugger
      if(index == 0){
        this.page = 1;
        this.total = 0;
        this.threeTags = [];
        this.twoTagNum = item.id;
        //获取数据
        this.zsgSearch()
      }else if(index == 1){
        this.TagsName = '税务总局解读';
        //默认调用 税务总局解读 数据
        this.zcjdChildListClick(item.childs[0],0)
      }else{
        //调用大模型
        this.getSeeAsk('gzsc')
      }
    },
    //政策解读下的几个子分类的点击
    zcjdChildListClick(item,index){
      if (this.eventSource) {
        this.ctrl.abort()
        this.sseshow = false
        this.markdownContent = ''
        this.eventSource = null
        this.ctrl = null
      }

      //节流
      // if(this.zcjdChildTypeIndex == index){
      //   return
      // }
      this.zcjdChildTypeIndex = index;
      this.TagsName = item.name;
      //获取税务总局解读 中央部门解读 地方税收解读 的数据
      this.twoTagNum = item.id;
      this.page = 1;
      this.threeTags = [];
      this.total = 0;
      this.zsgSearch()

      // if (this.twoTags[index] && this.twoTags[index].childs) {
      //   this.threeTags = this.twoTags[index].childs
      //   this.threeTagFun(this.threeTags[0].id, 0)
      // } else {
      //   if (this.tagTreeId) {
      //     this.TagsName = this.twoTags[index].name
      //     this.zsgSearch()
      //   }
      // }
    },
    sendTotalFN(data){
      this.total = data.total
    },
    

    //大模型
    getSeeAsk(code){
      let that = this
      this.objdata.code = code
      this.objdata.userFlag = ""
      //this.objdata.ask = this.crumbslist[this.crumbslist.length-1];
      let newText = this.crumbslist.join('-')
      this.objdata.ask = newText;
      this.objdata.area = ''
      this.objdata.contentType = ''
      this.objdata.sessionId = '';
    // this.eventSource = null
    let url = '/sseAI/ask?auth_sign=eJw1jN0KgjAARt9l19Hm3LQJXZQlUgr9aFB3rrkcmplpWtG7J2KX3*Gc7wMCbz9*xiWwAB4jMOr3Q6RRUSjRwVZ-Zz6nyctxgsOsaQdDiTivlFR9yASVmtQl4RRFjGB2RsaEI4IIphJx-n9Vl05Ok60ywqUPd3N7swrWeQ2Vd5cNLxehfYKuU9-cYwv1NCPTIazUNQaWZmKGqYkNZprk*wMRkDZ6&auth_ts=1729257269774&auth_code=zsdy'
    this.ctrl = new AbortController()
    this.eventSource = new fetchEventSource(url, {
      // 这里设置请求头信息
      method: 'POST',
      body: JSON.stringify(this.objdata),
      headers: {
        'Content-Type': 'application/json',
      },
      signal: this.ctrl.signal,
      onmessage(event) {
        let obj = JSON.parse(event.data)
        if (obj.status == 0) {
          let content = obj.data.output.text || ''
          if (content) {
            let rc = content.replaceAll('\n', '<br>')
            that.markdownContent += rc
          }
        } else {
          console.log('出错了')
        }
      },
      onclose(ee) {
        // 关闭流
        console.info('关闭了关闭了关闭了', ee)
      },
      onerror(error) {
        console.info(error, 'sssssssssss')
        // this.stopSSE()
        //返回流报错
      },
    })
    },
    // 监听内容滚动
    scroll: function (e) {
        this.old.scrollTop = e.detail.scrollTop; // 必要
        if (e.detail.scrollTop < 0) {
          uni.pageScrollTo({
              scrollTop: 0,
              duration: 100,
          });
        }
    },
    //触底函数 没有实际操作
    loadMore(){
      
    },


    // 过滤html
    textFil(v) {
      let a = v.replace(/\u3000/g, '')
      return a
    },
    newName(v) {
      v.forEach((element) => {
        if (element.attribute.extend.name) {
        } else {
          element.attribute.extend.name = element.name
        }
        if (element.childs) {
          this.newName(element.childs)
        }
      })
    },
    // 官网跳转过来的ID过滤
    gwForEach(v) {
      v.forEach((element) => {
        //element.attribute.extend.tagIds  做了一个判断
        if (element.id == this.tagTreeId) {
          this.tagTreeId = element.id
          this.fgzsTreeId = element.attribute.extend.tagIds
          this.tagIds = element.attribute.extend.tagIds
          this.crumbslist.unshift(element.attribute.extend.name)
          //debugger
          // 默认展开
          this.getRoleTreeRootNode(this.tagTreeId)
          // 法规注释
          //this.fgzsFun()
        } else if (element.childs) {
          this.gwForEach(element.childs)
        }
      })
    },
    //遍历数据 获取对应的path
    eachDataFN(allList,arr){
        for(let a=0;a<allList.length;a++){
            let pathArr = JSON.parse(JSON.stringify(arr));
            pathArr.push(allList[a].name);
            allList[a].pathArr = pathArr
            if(allList[a].childs&&allList[a].childs.length!=0){
                this.eachDataFN(allList[a].childs,allList[a].pathArr)
            }
        }
        return allList
    },
    // 标签树
    tagTree(six) {
      let data = new FormData()
      data.append('rootCategoryId', this.rootId)
      data.append('categoryType', 'zhzsk_zsg_tag_type')
      data.append('orderField', 'sort')
      data.append('orderType', 'desc')
      categoryCategoryTree(data)
        .then((res) => {
          console.log(res, '标签树')
          let tRes = res.data.data
          let newArr = this.eachDataFN(tRes,[])
          this.treeData = newArr;

          //console.log(this.tagTreeId, '官网跳转过来的ID')
          this.newName(this.treeData)
          this.cccFun(this.treeData)
          this.eachTree(this.treeData, '')
          //console.log(this.treeData);
          this.numberFun(this.treeData)
          this.getEquipmentList(six)
          // 官网跳转
          if (this.propsDATA.from == 'gw') {
            this.gwForEach(this.treeData)
          } else {
            this.tagTreeId = this.treeData[0].id
            this.fgzsTreeId = this.treeData[0].attribute.extend.tagIds
            this.tagIds = this.treeData[0].attribute.extend.tagIds
            this.zsgSearch()
            // 法规注释
            this.fgzsFun()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //获取左侧树的height
    getLeftTreeHeight() {
      //外层dom
      let leftTreeDom = document.getElementsByClassName('el-tree ')[0]
      //获取描蓝的dom
      let addBlueDom = document.getElementsByClassName('is-current')[0]
      //描蓝dom的top
      let blueTop = addBlueDom.getBoundingClientRect().top
      //爹top
      let leftTreeDomTop = leftTreeDom.getBoundingClientRect().top
      if (blueTop >= leftTreeDomTop + leftTreeDom.offsetHeight) {
        leftTreeDom.scrollTop =
          blueTop - (leftTreeDomTop + leftTreeDom.offsetHeight) + 700
      }
    },
    // 列表接口
    zsgSearch() {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let data = {
        size: this.size,
        page: this.page,
        categoryId: '',
        tagCategoryId: this.tagTreeId,
      }
      // 判断当前分类下是否有子分类如果有以子分类id为查询id
      if (this.twoTags != false) {
        data.categoryId = this.twoTagNum
        //data.categoryId = this.oneTagNum
      } else {
        data.categoryId = this.oneTagNum
      }
      // 变迁特殊字段
      // if(this.twoTagNum == 5880){
      //   data.searchAggField = this.name
      // }
      zsgSearch(data)
        .then((res) => {
          console.log(res, '列表数据')
          this.total = res.data.data.count
          if (this.total != 0) {
            if (res.data.data.contents) {
              this.list = res.data.data.contents
            } else {
              this.list = []
            }
          }else{
            //调用大模型
            this.getSeeAsk('gzsc')
          }
          /*if (this.oneTagNum == 5880) {
            let arr = []
            let num = 0
            for (const key in res.data.data.countMap) {
              if (Object.hasOwnProperty.call(res.data.data.countMap, key)) {
                const element = res.data.data.countMap[key]
                console.log(element, key)
                arr.push({ name: key, num: element })
                num += element
              }
            }
            console.log(arr, num)
            console.log(res.data.data.countMap, '政策变迁分类')
            this.fgbqTagTotal = num
            this.fgbqTagList = arr
            if (this.fgbqTagList != false) {
              this.fgbqTagFun(this.fgbqTagList[0].name)
            } else {
              this.fgbqTagFun()
            }
          }*/
          this.loading.close()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 一级分类 二级分类 三级分类
    categoryCategoryTree() {
      let data = new FormData()
      data.append('rootCategoryId', 5872)
      data.append('categoryType', 'zhzsk_zsg_type')
      data.append('orderField', 'sort')
      data.append('orderType', 'desc')
      categoryCategoryTree(data)
        .then((res) => {
          console.log(res.data.data, '一二三级分类')
          let newData = JSON.parse(JSON.stringify(res.data.data));
          newData[0].childs[0] = res.data.data[0].childs[1]
          newData[0].childs[1] = res.data.data[0].childs[0]
          this.tagsList = newData
          //this.tagsList = res.data.data
          if (this.propsDATA.from == 'gw') {
          } else {
            this.oneTagFun(this.tagsList[0].id, 0)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    oneTagFun(v, k, l) {
      if (v == 5884) {
        if (this.$store.state.user && this.$store.state.user.login != true) {
          let str1 = ''
          let data1 = {
            tagIds: this.tagIds,
          }
          cmsDataGetTagNames(data1).then((res) => {
            console.log(res.data.data)
            str1 += res.data.data
            str1 = encodeURIComponent(str1.trim())
            let url = dyLink + 'result?type=search&searchKey=' + str1
            window.open(url)
          })
        } else {
          this.$confirm('登录后可查看', '未登录', {
            confirmButtonText: '登录',
            cancelButtonText: '取消',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning',
          })
            .then(() => {
              this.$parent.$parent.login(true)
            })
            .catch(() => {})
        }
      } else {
        this.oneTagNum = v
        this.page = 1
        console.log(this.oneTagNum, '一级标签3')
        this.twoTags = []
        if (this.tagsList[k] && this.tagsList[k].childs) {
          this.twoTags = this.tagsList[k].childs
          if (l) {
            this.twoTagFun(this.twoTags[l].id, l)
          } else {
            this.twoTagFun(this.twoTags[0].id, 0)
          }
        } else {
          this.TagsName = this.tagsList[k].name
          this.zsgSearch()
        }
      }
    },
    twoTagFun(v, k, l) {
      // 相关国家政策 和 相关地方政策跳转官网 使用l参数
      if (v == 5881 || v == 5882 || v == 5884) {
        switch (v) {
          case 5884:
            if (
              this.$store.state.user &&
              this.$store.state.user.login != true
            ) {
              let str1 = ''
              let data1 = {
                tagIds: this.tagIds,
              }
              cmsDataGetTagNames(data1).then((res) => {
                console.log(res.data.data)
                str1 += res.data.data
                str1 = encodeURIComponent(str1.trim())
                let url = dyLink + 'result?type=search&searchKey=' + str1
                window.open(url)
              })
            } else {
              this.$confirm('登录后可查看', '未登录', {
                confirmButtonText: '登录',
                cancelButtonText: '取消',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'warning',
              })
                .then(() => {
                  this.$parent.$parent.login(true)
                })
                .catch(() => {})
            }

            break

          default:
            if (
              this.$store.state.user &&
              this.$store.state.user.login != true
            ) {
              let str = ''
              let data = {
                tagIds: this.tagIds,
              }
              // 对应官网的国家税收 或 地方税收
              switch (v) {
                case 5881:
                  v = 4014
                  break
                case 5882:
                  v = 4015
                  break
              }
              cmsDataGetTagNames(data).then((res) => {
                console.log(res.data.data)
                str += res.data.data
                str = str.replace(/\%/g, '%25')
                str = str.replace(/\#/g, '%23')
                str = str.replace(/\&/g, '%26')
                str = str.replace(/\?/g, '%3F')
                let url =
                  searchLink +
                  '?' +
                  '&id=' +
                  v +
                  '&keyword=' +
                  str +
                  '&searchType=2'
                window.open(url)
              })
            } else {
              this.$confirm('登录后可查看', '未登录', {
                confirmButtonText: '登录',
                cancelButtonText: '取消',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'warning',
              })
                .then(() => {
                  this.$parent.$parent.login(true)
                })
                .catch(() => {})
            }

            break
        }
      } else {
        this.twoTagNum = v
        this.page = 1
        console.log(this.twoTagNum, '二级标签')
        this.threeTags = []
        if (this.twoTags[k] && this.twoTags[k].childs) {
          this.threeTags = this.twoTags[k].childs
          this.threeTagFun(this.threeTags[0].id, 0)
        } else {
          if (this.tagTreeId) {
            this.TagsName = this.twoTags[k].name
            this.zsgSearch()
          }
        }
      }
    },
    threeTagFun(v, k) {
      this.threeTagNum = v
      this.page = 1
      this.TagsName = this.threeTags[k].name
      console.log(this.threeTagNum, '三级标签')
      this.zsgSearch()
    },
    // 法规注释
    fgzsFun() {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let data = {
        page: this.page,
        size: this.size,
        tagTreeIds: [this.fgzsTreeId],
        type: 0,
      }
      dataSearch(data).then((res) => {
        this.fgzsList = res.data.rows
        console.log(this.$refs)
        this.$nextTick(() => {
          this.$refs.hidden.className = ''
          console.log(this.$refs.hidden.offsetHeight)
          if (this.$refs.hidden.offsetHeight > 96) {
            this.mcBol = true
            this.$refs.hidden.className = 'fgzsShow'
            this.mcBtnBol = false
          } else {
            this.mcBol = false
            this.$refs.hidden.className = ''
            this.mcBtnBol = false
          }
        })
        this.loading.close()
      })
    },
    expandeClick(v) {
      if (this.mcBtnBol) {
        this.$refs.hidden.className = 'fgzsShow'
      } else {
        this.$refs.hidden.className = ''
      }
      this.mcBtnBol = !this.mcBtnBol
      this.$forceUpdate()
    },
    cmsDictionaryDataList(v) {
      let data = {
        dictionaryId: v,
      }
      cmsDictionaryDataList(data).then((res) => {
        // 对接CMS 获取查法规的标签
        switch (v) {
          case 'zsgSearchFG':
            let arr = []
            for (let i = 0; i < res.data.list.length; i++) {
              const element = res.data.list[i]
              arr.push(Number(element.id.value))
            }
            console.log(arr)
            this.abc = arr
            break
          // 对接cms 获取不显示的标签
          case 'zsgHideTag':
            for (let i = 0; i < res.data.list.length; i++) {
              const element = res.data.list[i]
              this.abcd.push(Number(element.id.value))
            }
            break
        }
      })
    },
    cmsDataSearchTagIsHave(v) {
      let data = v
      data.areaTagTreeNames = []
      data.jdTypeList = [7]
      console.log(this.jdTagsList)
      this.jdTagsList.forEach((el) => {
        if (el.id !== '0') {
          data.areaTagTreeNames.push(el.name)
        }
      })
      console.log(data)
      cmsDataSearchTagIsHave(data).then((res) => {
        console.log(res.data.data)
        this.dqList = res.data.data
        if (this.dqList.length > 0) {
          this.dqList.push('全部')
        }
      })
    },
    cmsDataSearchFgbqTypeList(v) {
      let data = v
      console.log(data)
      cmsDataSearchFgbqTypeList(data).then((res) => {
        console.log(res.data.data)
        let arr = []
        let num = 0
        for (const key in res.data.data) {
          if (Object.hasOwnProperty.call(res.data.data, key)) {
            const element = res.data.data[key]
            console.log(element, key)
            arr.push({ name: key, num: element })
            num += element
          }
        }
        // debugger
        console.log(num)
        this.fgbqTagTotal = num
        this.fgbqTagList = arr
        if (this.fgbqTagList != false) {
          this.fgbqTagFun(this.fgbqTagList[0].name)
        } else {
          this.fgbqTagFun()
        }
      })
    },
    fgbqTagFun(v) {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      let data = {
        size: this.size,
        page: this.page,
        categoryId: '',
        tagCategoryId: this.tagTreeId,
        searchAggField: v,
      }
      if (this.twoTags != false) {
        data.categoryId = this.twoTagNum
      } else {
        data.categoryId = this.oneTagNum
      }
      this.fgbqTagNum = v
      zsgSearch(data).then((res) => {
        console.log(res)
        if (res.data.data.contents) {
          this.list = res.data.data.contents
        } else {
          this.list = []
        }
        this.total = res.data.data.count
        // //字段null判断
        // for (let a = 0; a < this.list.length; a++) {
        //   if (this.list[a].parentList == null) {
        //     this.list[a].parentList = [];
        //   }
        // }
        // // if (this.tagNum == 3) {
        // //   this.fgbq.size = this.list.length;
        // //   this.list.forEach((element) => {
        // //     this.fgbq.list.push(element.fgbqType);
        // //   });
        // //   let arr = new Set(this.fgbq.list);
        // //   this.fgbq.list = arr;
        // //   this.fgbq.list.forEach((element) => {
        // //     this.fgbq.text += element + "，";
        // //   });

        // //   console.log(this.fgbq);
        // // }
        // for (let a = 0; a < this.list.length; a++) {
        //   let indexStr = "<p>";
        //   let content = this.list[a].content;
        //   content = content.replace(
        //     /style=\"text-indent: 2em;\"/g,
        //     /style="text-indent: 0em;"/
        //   );
        //   content = content.replace("<html>\n <head></head>\n <body>\n", "");
        //   content = content.replace("</body></html>", "");
        //   //前端做判断 有些地方会多余出空格 有的没空格 正则替换在做拼接
        //   content = content.replace(/<p\b[^<>]*>/, "");
        //   content = content.trim();
        //   content = indexStr + content;
        //   content = content.replace("<br/>", "");
        //   content = content.slice(0, -4) + content.slice(-4);
        //   this.list[a].content = content;
        //   if (this.list[a].fgbqList) {
        //     this.list[a].fgbqList.forEach((element) => {
        //       let content2 = element.content;
        //       content2 = content2.replace(
        //         /style=\"text-indent: 2em;\"/g,
        //         /style="text-indent: 0em;"/
        //       );
        //       element.content = content2;
        //     });
        //   }
        //   // for(let b=0;b<thatRowData[a].similar.length;b++){
        //   // 	let indexStr = '<p>' ;
        //   // 	let content = thatRowData[a].similar[b].content
        //   // 	//前端做判断 有些地方会多余出空格 有的没空格 正则替换在做拼接
        //   // 	content = content.replaceAll(/<p\b[^<>]*>/, '');
        //   // 	content = content.trim();
        //   // 	content = indexStr+content;
        //   // 	content = content.replace("<br/>", "");
        //   // 	content = content.slice(0, -4) + content.slice(-4);
        //   // 	thatRowData[a].similar[b].content = content
        //   // }
        // }
        this.loading.close()
      })
      // document.getElementById('fgbq'+v).scrollIntoView({behavior:'smooth'});
    },
    dfJdFun(v) {
      this.jdTagsId = v
      this.zsgSearch()
    },
    dqFun(v) {
      let data = {
        rootId: 998800,
        // rootId: 996423,
        typeIds: '',
        level: 1,
      }
      if (v) {
        data.rootId = 996423
      }
      tagTreeCache(data).then((res) => {
        //console.log(res);
        if (v) {
          this.szTagsList = res.data.data.children
          this.szTagsList.unshift({ id: '0', name: '全部' })
        } else {
          this.jdTagsList = res.data.data.children
          this.jdTagsList.unshift({ id: '0', name: '全部' })
          this.jdTagsList.pop()
          this.jdTagsList.pop()
          this.jdTagsList.pop()
        }
      })
    },
    jdFun(v) {
      this.xgjdText = v
      this.jdSearchFun()
    },
    jdSearchFun(v) {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let data = {
        page: this.page,
        size: this.size,
        tagTreeIds: [this.tagTreeId],
        jdTypeList: [1],
        type: this.tagNum,
        areaTagTreeIds: [],
      }
      // if(this.isTopTag){
      //   data.isTopTag = true
      // }
      switch (this.xgjdText) {
        case '税务总局解读':
          data.jdTypeList = [1]
          break
        case '中央部门解读':
          data.jdTypeList = [3]
          break
        case '地方税收解读':
          data.jdTypeList = [7]
          break
      }
      // debugger
      if (v && v !== '0') {
        data.areaTagTreeIds = [v]
      }
      dataSearch(data).then((res) => {
        this.fgbq = {
          size: 0,
          list: [],
          text: '',
        }
        console.log(res)
        this.list = res.data.rows
        //字段null判断
        for (let a = 0; a < this.list.length; a++) {
          if (this.list[a].parentList == null) {
            this.list[a].parentList = []
          }
        }
        this.total = res.data.total
        this.cmsDataSearchTagIsHave(data)
        // if (this.tagNum == 3) {
        //   this.fgbq.size = this.list.length;
        //   this.list.forEach((element) => {
        //     this.fgbq.list.push(element.fgbqType);
        //   });
        //   let arr = new Set(this.fgbq.list);
        //   this.fgbq.list = arr;
        //   this.fgbq.list.forEach((element) => {
        //     this.fgbq.text += element + "，";
        //   });

        //   console.log(this.fgbq);
        // }
        for (let a = 0; a < this.list.length; a++) {
          let indexStr = '<p>'
          let content = this.list[a].content
          content = content.replace(
            /style=\"text-indent: 2em;\"/g,
            /style="text-indent: 0em;"/
          )
          content = content.replace('<html>\n <head></head>\n <body>\n', '')
          content = content.replace('</body></html>', '')
          //前端做判断 有些地方会多余出空格 有的没空格 正则替换在做拼接
          content = content.replace(/<p\b[^<>]*>/, '')
          content = content.trim()
          content = indexStr + content
          content = content.replace('<br/>', '')
          content = content.slice(0, -4) + content.slice(-4)
          this.list[a].content = content

          // for(let b=0;b<thatRowData[a].similar.length;b++){
          // 	let indexStr = '<p>' ;
          // 	let content = thatRowData[a].similar[b].content
          // 	//前端做判断 有些地方会多余出空格 有的没空格 正则替换在做拼接
          // 	content = content.replaceAll(/<p\b[^<>]*>/, '');
          // 	content = content.trim();
          // 	content = indexStr+content;
          // 	content = content.replace("<br/>", "");
          // 	content = content.slice(0, -4) + content.slice(-4);
          // 	thatRowData[a].similar[b].content = content
          // }
        }
        this.loading.close()
      })
    },
    jump(v) {
      window.open(v)
    },
    contentJump(v, k, l) {
      if (this.$store.state.user && this.$store.state.user.login != true) {
        console.log(this.tagIds)
        let Detail = this.$router.resolve({
          path: '/content',
          query: {
            contentId: v,
            keyWord: this.name,
            contentIds: k,
            tagTreeId: this.tagIds,
            type: l,
          },
        })
        window.open(Detail.href, '_blank')
      } else {
        this.$confirm('登录后可查看', '未登录', {
          confirmButtonText: '登录',
          cancelButtonText: '取消',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning',
        })
          .then(() => {
            this.$parent.$parent.login(true)
          })
          .catch(() => {})
        // this.$notify({
        //   title: '未登录',
        //   message: '登录后可查看详情页',
        //   type: 'warning',
        //   offset: 100,
        //   duration:3000,
        //   onClick: setTimeout(() => {
        //     this.$parent.$parent.login(true)
        //   }, 2000)
        // });
      }
    },
    fgFun(v) {
      let text = ''
      switch (v) {
        case 4014:
          text = '国家税收法规'
          break
        case 4015:
          text = '地方税收政策'
          break
      }
      // let a = this.name.indexOf('.');
      // let b =  this.name.slice(a+1);
      let str = ''
      let data = {
        tagIds: this.tagTreeId,
      }
      cmsDataGetTagNames(data).then((res) => {
        console.log(res.data.data)
        str += res.data.data
        str = str.replace(/\%/g, '%25')
        str = str.replace(/\#/g, '%23')
        str = str.replace(/\&/g, '%26')
        str = str.replace(/\?/g, '%3F')
        let url =
          searchLink + '?' + '&id=' + v + '&keyword=' + str + '&searchType=2'
        window.open(url)
      })
    },
    handleCurrentChange(v) {
      this.page = v
      this.zsgSearch()
    },
    tagFun(v) {
      if (v == '4') {
        let str = ''
        let data = {
          tagIds: this.tagTreeId,
        }
        cmsDataGetTagNames(data).then((res) => {
          console.log(res.data.data)
          str += res.data.data
          str = encodeURIComponent(str.trim())
          let url = dyLink + 'result?type=search&searchKey=' + str
          window.open(url)
        })
      } else {
        this.tagNum = v
        this.list = []
        this.page = 1
        this.dataSearch()
      }
    },
    // 内容数据
    dataSearch() {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let data = {
        page: this.page,
        size: this.size,
        tagTreeIds: [this.tagTreeId],
        type: this.tagNum,
      }
      if (this.tagNum == 1 && this.isTopTag) {
        data.isTopTag = true
      }
      if (this.tagNum == 1) {
        if (this.aaa == '6') {
          data.type = '6'
        }
      }
      if (this.tagNum == 1) {
        if (data.tagTreeIds[0] == 6635683 || data.tagTreeIds[0] == 6635684) {
          data.type = '6'
          this.aaa = '6'
        }
      }
      if (this.tagNum == 2) {
        this.jdSearchFun()
      } else if (this.tagNum == 3) {
        this.cmsDataSearchFgbqTypeList(data)
      } else {
        dataSearch(data).then((res) => {
          this.fgbq = {
            size: 0,
            list: [],
            text: '',
          }
          console.log(res)
          this.list = res.data.rows
          this.total = res.data.total
          // 判断名词解释里没有数据 跳转到法规依据
          if (this.tagNum === '0' && this.total == 0) {
            this.tagNum = '1'
            this.$forceUpdate()
            this.dataSearch()
          }
          // if (this.tagNum == 3) {
          //   this.fgbq.size = this.list.length;
          //   this.list.forEach((element) => {
          //     this.fgbq.list.push(element.fgbqType);
          //   });
          //   let arr = new Set(this.fgbq.list);
          //   this.fgbq.list = arr;
          //   this.fgbq.list.forEach((element) => {
          //     this.fgbq.text += element + "，";
          //   });
          //   console.log(this.fgbq);
          // }
          for (let a = 0; a < this.list.length; a++) {
            let indexStr = '<p>'
            let content = this.list[a].content
            // content = content.replace(/style=\"text-indent: 2em;\"/g, /style="text-indent: 0em;"/);
            content = content.replace(/text-indent: 2em/g, /text-indent: 0em/)
            content = content.replace('<html>\n <head></head>\n <body>\n', '')
            content = content.replace('</body></html>', '')
            //前端做判断 有些地方会多余出空格 有的没空格 正则替换在做拼接
            content = content.replace(/<p\b[^<>]*>/, '')
            content = content.trim()
            content = indexStr + content
            content = content.replace('<br/>', '')
            content = content.slice(0, -4) + content.slice(-4)
            this.list[a].content = content

            // for(let b=0;b<thatRowData[a].similar.length;b++){
            // 	let indexStr = '<p>' ;
            // 	let content = thatRowData[a].similar[b].content
            // 	//前端做判断 有些地方会多余出空格 有的没空格 正则替换在做拼接
            // 	content = content.replaceAll(/<p\b[^<>]*>/, '');
            // 	content = content.trim();
            // 	content = indexStr+content;
            // 	content = content.replace("<br/>", "");
            // 	content = content.slice(0, -4) + content.slice(-4);
            // 	thatRowData[a].similar[b].content = content
            // }
          }
          this.loading.close()
        })
      }
    },
    numberFun(v) {
      //console.log(v)
      for (let i = 0; i < v.length; i++) {
        let element = v[i]
        element.attribute.extend.name =
          i + 1 + '. ' + element.attribute.extend.name
        // if(v[i].children == null){
        //   // return
        // }else{
        //   this.numberFun(v[i].children)
        // }
      }
    },
    cccFun(v) {
      for (let i = 0; i < v.length; i++) {
        const element = v[i]
        if (this.abcd.indexOf(element.id) != -1) {
          // v.splice(this.abcd.indexOf(element.id),1)
          //console.log(element.id);
          //console.log(i);
          v.splice(i, 1)
          //console.log(v);
          this.cccFun(v)
        } else if (element.children != false && element.children != null) {
          // debugger
          this.cccFun(element.children)
        }
      }
    },
    tree(six) {
      let data = {
        rootId: this.rootId,
        typeIds: '',
      }
      tagTreeCache(data).then((res) => {
        //console.log(res);
        this.treeData = res.data.data.children
        // 9.13修改  后四个分类协助隐藏（15.批发零售业 16.国际组织 17.租赁和商务服务业 18.科学研究和技术服务业）
        if (this.rootId == '6562083') {
          this.treeData.pop()
          this.treeData.pop()
          this.treeData.pop()
          this.treeData.pop()
        }
        this.cccFun(this.treeData)
        this.eachTree(this.treeData, '')
        //console.log(this.treeData);
        this.numberFun(this.treeData)
        this.getEquipmentList(six)
        this.dataSearch()
        // 法规注释
        this.fgzsFun()
      })
    },
    //遍历获取到的tree数据
    eachTree(arr, path) {
      for (let a = 0; a < arr.length; a++) {
        let tPath = path + arr[a].name + '/'
        arr[a]['path'] = tPath
        if (arr[a].children && arr[a].children.length != 0) {
          this.eachTree(arr[a].children, tPath)
        }
      }
    },
    crumbsFun(v) {
      if (v.parent != null) {
        this.crumbslist.unshift(v.data.attribute.extend.name)
        this.crumbsFun(v.parent)
      } else {
        console.log(this.list)
      }
    },
    // crumbsFuns(v,k) {
    //   // debugger
    //   let list = [];
    //   console.log(v);
    //   k.forEach(element => {
    //     console.log(element);
    //     if (element.id == v) {
    //       console.log(element,518);
    //       this.crumbslist.unshift(element.name);
    //     }else{
    //       if(element.children){
    //         this.crumbsFuns(v,element.children)
    //       }
    //     }
    //   });
    //   for (let i = 0; i < k.length; i++) {
    //     const element = k[i];
    //     if(element.id == v){
    //       this.crumbslist.unshift(element.name);
    //     }else if(element.children){
    //       for (let a = 0; a < element.children.length; a++) {
    //         const elementA = element.children[a];
    //         if(elementA.id == v){

    //         }
    //       }
    //     }
    //   }
    // },
    // 获取树形结构默认展开节点
    getRoleTreeRootNode(provincialCenterId) {
      //debugger
      this.treeExpandData.push(provincialCenterId)
      if (this.propsDATA.from == 'gw') {
        switch (Number(this.propsDATA.searchType)) {
          case 2:
            this.oneTagFun(5883, 1)
            break
          case 3:
            this.oneTagFun(5880, 3)
            break
          // case 4:
          //   this.twoTagFun(5884);
          //   break;
          case 5:
            this.oneTagFun(5885, 4)
            break
          default:
            this.oneTagFun(5873, 0)
            break
        }
      }
    },
    //获取tree树列表
    getEquipmentList(params) {
      //console.log(this.treeData);
      this.keyId = this.treeData[0].id //默认选中节点
      // this.keyId = 6569326;
      if (this.abc.includes(this.treeData[0].id)) {
        this.aaa = '6'
        // console.log(6666666);
      } else {
        this.aaa = ''
      }

      this.tagTreeId = this.treeData[0].id
      this.tagIds = this.treeData[0].attribute.extend.tagIds
      if (this.propsDATA.id) {
        this.tagTreeId = Number(this.propsDATA.id)
      }
      this.$nextTick(() => {
        this.$refs.eltree.setCurrentKey(this.tagTreeId)
      })
      this.name = this.treeData[0].attribute.extend.name

      let a = this.name.indexOf('.')
      let b = this.name.slice(a + 1)
      this.name = b
      this.crumbslist.unshift(
        this.treeData[0].attribute.extend.name
        // this.treeData[0].children[0].name
      ) //默认面包屑
      if (this.propsDATA.id) {
        // this.crumbslist = [];
        // this.crumbsFuns(this.keyId,this.treeData)
      }
      // this.provincialCenterId = this.treeData[0].id; //默认展开第一个节点
      // this.provincialCenterId = 6569326;

      //判断是否是从官网首页跳转进来的 liyanze分支增加
      if (this.propsDATA.from == 'gw') {
        if (this.propsDATA.pId) {
          //将id转为数字类型
          let numberStr = Number(this.propsDATA.pId)
          //默认展开
          this.treeExpandData = [numberStr]
          this.tagTreeId = this.propsDATA.tagTreeId
          this.tagNum = this.propsDATA.searchType
        } else {
          //this.provincialCenterId = 6557381;
          this.tagTreeId = this.propsDATA.tagTreeId
          this.tagNum = this.propsDATA.searchType
        }
      }

      //判断是否是初始传了个6
      if (params && params == 6) {
        this.aaa = '6'
        let textArr = []
        textArr = this.eachListFN(
          this.propsDATA.tagTreeId,
          this.treeData,
          ''
        )
        //字符串转成数组
        let pathArr = textArr.split('/')
        pathArr = pathArr.slice(0, pathArr.length - 1)
        this.crumbslist = pathArr
      }

      if (this.propsDATA.id) {
        // 解决cms首页跳转至中税官配置的id为九大手册的id时取当前手册第一个标签的id
        switch (Number(this.propsDATA.id)) {
          case 6557331:
            //this.provincialCenterId = Number(this.treeData[0].id);
            this.provincialCenterId = 6557381
            this.tagTreeId = 6557381
            //this.tagTreeId = Number(this.treeData[0].id);
            break
          case 6558575:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6561976:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6562083:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6563043:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6563911:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6564398:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6564533:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          case 6565603:
            this.provincialCenterId = Number(this.treeData[0].id)
            this.tagTreeId = Number(this.treeData[0].id)
            break
          default:
            this.provincialCenterId = Number(this.propsDATA.id)
            break
        }
      }
      // this.getRoleTreeRootNode(this.provincialCenterId);
      // 默认展开
      if (this.propsDATA.from == 'gw') {
      } else {
        this.getRoleTreeRootNode(this.treeData[0].id)
      }
    },
    aaaFun(v) {
      if (this.abc.includes(v.data.id)) {
        this.aaa = '6'
        // console.log(6666666666);
      } else if (v.level != 1) {
        // debugger
        this.aaaFun(v.parent)
      } else {
        this.aaa = ''
      }
    },
    handleNodeClick(data, node) {

      if (this.eventSource) {
        this.ctrl.abort()
        this.sseshow = false
        this.markdownContent = ''
        this.eventSource = null
        this.ctrl = null
      }


      let treeObj = {
        name:data.name,
        id:data.id,
        pathArr:data.pathArr,
        count:data.count
      }
      this.showPathName = treeObj.pathArr
      this.rightShowTreeInfo.name = treeObj.name


      console.log(data)
      console.log(node)
      this.aaaFun(node)
      this.crumbslist = []
      this.crumbsFun(node)
      this.tagTreeId = data.id
      this.tagIds = data.attribute.extend.tagIds
      this.fgzsTreeId = data.attribute.extend.tagIds
      this.name = data.attribute.extend.name
      let a = this.name.indexOf('.')
      let b = this.name.slice(a + 1)
      this.name = b
      this.list = []
      this.page = 1
      // if(node.level == 1){
      //   this.isTopTag = true
      // }else{
      //   this.isTopTag = false
      // }
      
      //判断分类 是调用数据还是调用大模型
      if(this.rightTopTypeIndex ==0||this.rightTopTypeIndex ==1){
        //this.fgzsFun()
        this.zsgSearch()
      }else{
        let code = this.rightTopTypeList[this.rightTopTypeIndex].code
        this.markdownContent = ''
        this.total = 0;
        if (this.eventSource) {
          this.ctrl.abort()
          this.sseshow = false
          this.markdownContent = ''
          this.eventSource = null
          this.ctrl = null
        }
        this.getSeeAsk(code)
      }
      // this.tagTreeId = data.id
    },
    //遍历数据 获取当前id的path
    eachListFN(tId, list, text) {
      for (let a = 0; a < list.length; a++) {
        if (list[a].id == tId) {
          text = list[a].path
        } else {
          if (list[a].children && list[a].children.length != 0) {
            text = this.eachListFN(tId, list[a].children, text)
          }
        }
      }
      return text
    },
    renderContent: function (h, { node, data, store }) {
      // console.log(data);
      // console.log(node);
      // console.log(store);
      if (node.data.id == this.propsDATA.id) {
        //获取当前节点的path路径
        let textArr = []
        textArr = this.eachListFN(this.propsDATA.id, this.treeData, '')
        //字符串转成数组
        let pathArr = textArr.split('/')
        pathArr = pathArr.slice(0, pathArr.length - 1)
        this.crumbslist = pathArr
        console.log(pathArr)
      }
      /**
            这个addElement等于的是一个自身的索引为0的东西
            我也不晓得这是个啥回来console看看吧
            大概率是一个dom结构或者是新增dom的东西
        */
      let addElement = arguments[0]
      // 这里判断这个rain类型，是和上面 children 有关系
      /*
            反正在最后返回了一个dom元素，一个i标签和俩span标签
            i标签添加个类名是放置icon图标，后面空span不知道干嘛的
            最后一个span是吧你要填写的文字传进去，他拿的是自身的索引为1的里面的
            我懂了，这个索引应该就是参数，这里拿到的是第二个参数中的数据
         */
      if (node.level === 1) {
        // debugger
        if (node.expanded == false) {
          return (
            <div
              class="tOne"
              style="display:flex;width:calc(100% - 20px);min-height: 48px;padding:0 20px 0 0;line-height:48px;font-size:18px;color:#000;font-weight:700;font-family: SourceHanSansCN-Bold;"
            >
              <p style="width:270px;">
                {store.root.data[0].index}
                {node.label}
              </p>
              <div style="width: 24px;height: 24px">
                <img
                  src={blueAdd}
                  style="width: 24px;height: 24px;margin: 12px 0;"
                />
              </div>
            </div>
          )
        } else {
          return (
            <div
              class="tOne"
              style="display:flex;width:calc(100% - 20px);min-height: 48px;padding:0 20px 0 0;line-height:48px;font-size:18px;color:#000;font-weight:700;font-family: SourceHanSansCN-Bold;"
            >
              <p style="width:270px;line-height:;">{node.label}</p>
              <div style="width: 24px;height: 24px">
                <img
                  src={bluesubtract}
                  style="width: 24px;height: 24px;margin: 12px 0;"
                />
              </div>
            </div>
          )
        }
      } else if (node.level !== 1 && data.childs) {
        if (node.expanded == false) {
          return (
            <div
              class="tOne"
              style="display:flex; line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold"
            >
              <img
                src={add}
                style="width:15px;height:15px;margin-right:6px;margin-top:11px"
              />
              <p style="width:240px;word-wrap:break-word">{node.label}</p>
            </div>
          )
        } else {
          return (
            <div
              class="tOne"
              style="display:flex;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold"
            >
              <img
                src={subtract}
                style="width:15px;height:15px;margin-right:6px;margin-top:11px"
              />
              <p style="width:240px;word-wrap:break-word">{node.label}</p>
            </div>
          )
        }
      } else {
        if (node.isCurrent) {
          return (
            <div
              class="tOne"
              style="display:flex;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold"
            >
              <img
                src={blueTrue}
                style="width:15px;height:15px;margin-right:6px;margin-top:11px"
              />
              <p style="width:240px;word-wrap:break-word">{node.label}</p>
            </div>
          )
        } else {
          return (
            <div
              class="tOne"
              style="display:flex;line-height:36px;font-size:16px;color:#3d3d3d;font-family: SourceHanSansCN-Bold"
            >
              <img
                src={blank}
                style="width:15px;height:15px;margin-right:6px;margin-top:11px"
              />
              <p style="width:240px;word-wrap:break-word">{node.label}</p>
            </div>
          )
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bottomView{
margin-top:10px;
}
.notData{
  font-size: 12px;
  color: #333333;
  text-align: center;
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px 0px 0px 8px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
}
.treeNav{
  width:100%;
  height:24px;
  line-height: 24px;
  margin-top:10px;
  margin-bottom:20px;
  font-weight: 400;
  font-size: 18px;
  color: #3D3D3D;
  .leftHome{
    cursor:pointer;
  }
  .ruleName{
    padding-left:4px;
    color:#003FA8!important;
  }
}

/***右侧 顶部的几个分类 start*/
.topType{
  width: 870px;
  min-height: 90px;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
  margin-bottom:10px;
  .topTypeListBox{
    width: 870px;
    min-height: 90px;
    box-sizing: border-box;
    // padding:20px;
    padding:10px 20px 20px 20px;
    display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    .topTypeListCheck{
      background: #003FA8!important;
      color: #FFFFFF!important;
      border: 0px solid #888888!important;
    }
    .topTypeListNew{
      width: 160px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #888888;
      cursor:pointer;
      font-weight: 700;
      font-size: 16px;
      color: #3D3D3D;
      box-sizing: border-box;
      margin-top:10px;
    }
    .topTypeList{
      width: 110px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #888888;
      cursor:pointer;
      font-weight: 700;
      font-size: 16px;
      color: #3D3D3D;
      box-sizing: border-box;
    }
  }
  .zcgdChildType{
    width: 870px;
    min-height: 80px;
    background: #EEF8FF;
    overflow: hidden;
    .zcjdTypeChildListBox{
      width:100%;
      height:80px;
      box-sizing: border-box;
      padding:20px;
      .zcjdTypeChildListCheck{
        background: #003FA8!important;
        color: #FFFFFF!important;
      }
      .zcjdTypeChildList{
        width: 160px;
        height: 40px;
        line-height: 40px;
        float:left;
        text-align: center;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-right:8px;
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 700;
        font-size: 16px;
        color: #3D3D3D;
        cursor:pointer;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
      }
    }
    .zcgdChildListBox{
      width: 870px;
      height: 80px;
      box-sizing: border-box;
      padding-top:20px;
      .zcgdChildListCheck{
        background: #003FA8!important;
        font-weight: 700;
        color: #FFFFFF!important;
      }
      .zcgdChildList{
        width: 130px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
        float:left;
        margin-left:20px;
        font-weight: 400;
        font-size: 16px;
        color: #3D3D3D;
        cursor:pointer;
      }
    }
    .zcjdChildType{
      width: 420px;
      height:40px;
      line-height: 40px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
      border: 1px solid #DDDDDD;
      font-weight: 400;
      font-size: 16px;
      color: #3D3D3D;
      border-radius:20px;
      margin-left:25px;
      margin-bottom:20px;
      position: relative;
      .jianjiao{
        width:16px;
        height:16px;
        background: #ffffff;
        position: absolute;
        border-top:1px solid rgba(0,0,0,0.2);
        border-left:1px solid rgba(0,0,0,0.2);
        top:-9px;
        left:calc(50% - 10px);
        transform: rotate(45deg);
        box-shadow: -1px -1px 0px -2px rgba(0,0,0,0.2);
      }
      .zcjdChildListCheck{
        font-weight: 700!important;
        color: #003FA8!important;
      }
      #zcjdList1{
        p{
          border-left:1px solid #dddddd;
          border-right:1px solid #dddddd;
        }
      }
      .zcjdChildTypeList{
        width:140px;
        height:40px;
        float:left;
        text-align: center;
        box-sizing: border-box;
        padding:8px 0;
        line-height: 24px;
        font-weight: 400;
        font-size: 16px;
        color: #3D3D3D;
        cursor:pointer;
        -webkit-user-select: none;
        .sanjiaoxing{
          border-top:10px solid transparent;
          border-right:10px solid transparent;
          border-bottom:10px solid #ffffff;
          border-left:10px solid transparent;
          position: absolute;
          top:-20px;
          left:calc(50% - 20px);
          //box-shadow: 0px -2px 4px 0px rgba(0,0,0,0.2);
        }
      }
    }
  }
  .getDataTotalW{
    background: #ffffff!important;
  }
  .getDataTotal{
    width: 870px;
    height: 55px;
    line-height: 55px;
    background: #EEF8FF;
    box-sizing: border-box;
    padding-left:20px;
    font-weight: 400;
    font-size: 16px;
    color: #003FA8;
    .totalRed{
      color:#FF0000;
    }
  }
  
}
/***右侧 顶部的几个分类 end */



.fgzs {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  .fgzsTitle {
    width: calc(100% - 40px);
    height: 50px;
    padding: 0 20px;
    color: #003fa8;
    background: #eef8ff;
    font-size: 18px;
    font-weight: bold;
    line-height: 50px;
  }
  #hidden {
  }
  .fgzsContent {
    width: calc(100% - 40px);
    padding: 0 20px;
    font-size: 16px;
    line-height: 32px;
    color: #3d3d3d;
  }
  .fgzsShow {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    height: 96px;
  }
}
::v-deep .zsText p span {
  background-color: #f5f5f5 !important;
}
.crumbs {
  // height: 24px;
}
::v-deep .crumbs .el-breadcrumb__item:last-child {
  .el-breadcrumb__inner {
    color: #000 !important;
    font-weight: 700;
  }
}
.contentBox {
  padding-bottom: 24px;
}
.leftBox {
  /*width: 30%;*/
  width:320px;
  max-height: 800px;
  margin-right: 10px;
  //   background: #ff6700;
  display: inline-block;
  vertical-align: top;
  // overflow: auto;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.rightBox {
  /*width: calc(100% - 17px - 30%);*/
  width: calc(100% - 10px - 320px);
  // min-height: 800px;
  //   background: cyan;
  display: inline-block;
  vertical-align: top;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.icon {
  width: 10px;
  height: 10px;
  // background: url("@/assets/logo.png");
  background-size: 100% 100%;
}
.el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}
::v-deep .el-tree-node__content {
  font-size: 18px;
  color: #003fa8;
  line-height: 36px;
  height: 36px;
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: #eef8ff;
}
::v-deep .el-icon-caret-right:before {
  content: '';
}
::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
  padding: 0;
}
.tags {
  width: 100%;
  // height: 100px;
  // margin-bottom: 10px;
  background-color: #fff;

  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.tag {
  width: calc((100% - 50px) / 6);
  height: 48px;
  // background: #f5f5f5;
  font-size: 18px;
  line-height: 48px;
  color: #3d3d3d;
  text-align: center;
  cursor: pointer;
  border: 2px solid #cdcdcd;
  // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
}
.tagTrue {
  background: #003fa8;
  color: #ffffff;
  font-weight: bold;
  border: 2px solid #003fa8;
}
.listBox {
  // background: #fff;
  // background: #f5f5f5;
  margin-top: 10px;
}
.crumbsBox {
  width: calc(100% - 40px);
  // height: 42px;
  padding: 14px 20px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 18px;
  color: #3D3D3D;
  .lastSpan{
    color:#003FA8;
  }
}
.mcjsList {
  // background: #fff;
  width: calc(100%);
  // padding: 0 20px;
  .list {
    // height: 110px;
    background: #fff;
    padding: 0 20px;
    border-bottom: 1px solid #d8d8d8;
    .title {
      color: #003fa8;
      font-size: 16px;
      font-weight: bold;
      padding: 17px 0 11px;
    }
    .content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #3d3d3d;
    }
  }
  .list:first-child {
    // border-top: 1px solid #d8d8d8;
  }
}
.fgyjList {
  // background: #fff;
  width: calc(100%);
  // padding: 0 20px;
  .fgTags {
    padding: 0 20px;
    padding-bottom: 10px;
    .fgTag {
      display: inline-block;
      vertical-align: top;
      width: 130px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 18px;
      background: #f5f5f5;
      margin-right: 10px;
      margin-bottom: 2px;
      cursor: pointer;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    }
    .fgTagTrue {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      background: #003fa8;
    }
  }
  .jdTreeBox {
    padding: 10px 37px;
    .jdTags {
      // width: 64px;
      padding: 0 15px;
      height: 40px;
      background: #f8f8f8;
      margin-right: 10px;
      margin-bottom: 10px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      color: #bbb;
      display: inline-block;
      // cursor: not-allowed;
      cursor: pointer;
    }
    .fgTagTrue {
      color: #003fa8;
      font-size: 16px;
      font-weight: bold;
      background: #fff;
      cursor: pointer;
    }
    .fgTagTrue2 {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      background: #003fa8;
      cursor: pointer;
    }
  }
  .list {
    background: #fff;
    padding: 10px 20px;
    border-bottom: 1px solid #d8d8d8;
    .content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #3d3d3d;
    }
    .source {
      font-size: 14px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0em;
      color: #003fa8;
      background: #f5f5f5;
      cursor: pointer;
    }
    .timeBox {
      color: #003fa8;
      background: #f5f5f5;
      font-size: 14px;
      line-height: 32px;
      .time {
        margin-left: 50px;
      }
    }
  }
  .list:last-child {
    border: none;
  }
}
.dyalList {
  width: calc(100%);
  // padding: 0 20px;
  // background: #fff;
  .list {
    background: #fff;
    padding: 10px 10px;
    border-bottom: 1px solid #d8d8d8;
    .title {
      line-height: 36px;
      font-size: 16px;
      // font-weight: bold;
      color: #3d3d3d;
      background: #f5f5f5;
    }
    .content {
      line-height: 32px;
      font-size: 16px;
      // font-weight: bold;
      color: #3d3d3d;
      .sizeColor {
        padding-left: 14px;
      }
    }
    .time {
      line-height: 32px;
      font-size: 14px;
      // font-weight: bold;
      color: #003fa8;
    }
    .sizeColor {
      color: #003fa8;
    }
  }
  .list:last-child {
    border: none;
  }
}
.fgbqNum {
  background: #eef8ff;
  // border-radius: 0px 0px 8px 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  line-height: 30px;
  padding: 14px 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  .fgbqTags {
    width: 190px;
    height: 60px;
    background: #f5f5f5;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    .fgbqTagTitle {
      padding: 0 5px;
      width: calc(100% - 10px);
      height: 30px;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      color: #282828;
      white-space: nowrap; // 文字不换行
      overflow: hidden; // 超出隐藏
      text-overflow: ellipsis;
    }
    .fgbqTagSize {
      // width: 48px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      span {
        width: 48px;
        height: 16px;
        border-radius: 12px;
        background: #ffffff;
        text-align: center;
        display: inline-block;
        font-size: 12px;
        line-height: 16px;
        color: #888888;
        // color: #003fa8;
      }
    }
  }
  .act {
    background: #003fa8;
    .fgbqTagTitle {
      font-weight: bold;
      color: #fff;
    }
    .fgbqTagSize {
      span {
        color: #003fa8;
      }
    }
  }
}
.fgbqList {
  .fgbqTypeList {
    background: #fff;
    // border-radius: 0px 0px 8px 8px;
    margin-bottom: 10px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    .type {
      width: 100%;
      // height: 30px;
      padding: 10px 20px;
      .typeNum {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        height: 30px;
        background: #003fa8;
        border-radius: 0px 15px 15px 0px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        margin-right: 20px;
      }
      .typeIntro {
        display: inline-block;
        vertical-align: top;
        line-height: 30px;
      }
    }
    .list {
      padding: 15px 20px;
      .source {
        padding-left: 17px;
        font-size: 14px;
        font-weight: normal;
        line-height: 32px;
        letter-spacing: 0em;
        color: #003fa8;
        cursor: pointer;
      }
      .timeBox {
        padding-left: 17px;
        color: #003fa8;
        font-size: 14px;
        line-height: 32px;
        .time {
          margin-left: 50px;
        }
      }
      .title {
        padding: 0 10px;
        width: calc(100% - 20px);
        height: 36px;
        background: #eef8ff;
        line-height: 36px;
        font-size: 16px;
        color: #003fa8;
        font-weight: 700;
        .time {
          font-size: 14px;
          color: #3d3d3d;
          float: right;
          font-weight: 500;
        }
      }
      .titleFalse {
        color: #ff5555;
        background: #fff0f0;
      }
      .content {
        line-height: 32px;
        font-size: 16px;
        color: #3d3d3d;
        padding-left: 10px;
        margin-top: 7px;
      }
      .more {
        height: 24px;
        font-size: 16px;
        line-height: 24px;
        color: #00f;
        span {
          float: right;
          cursor: pointer;
        }
      }
    }
  }
}
.TagsBox {
  width: 100%;
  // height: 180px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  .oneTagsBox {
    width: 100%;
    height: 50px;
    background: #003fa8;
    .indexTag {
      background: #0055e4;
      .RBor {
        border-right: 2px solid #0055e4;
      }
    }
    .indexBefore {
      .RBor {
        border-right: 2px solid #003fa8;
      }
    }
    span {
      display: inline-block;
      text-align: center;
      line-height: 50px;
      color: #fff;
      cursor: pointer;
      .RBor {
        line-height: 1;
        padding: 0 19.5px;
        border-right: 2px solid #fff;
      }
    }
    span:last-child {
      .RBor {
        padding: 0 21px;
        border: none;
      }
    }
  }
  .twoTagsBox {
    width: calc(100%);
    padding: 25px 0 20px;
    background: #fff;
    .twoIndex {
      font-weight: 700;
      border: 1px solid #003fa8 !important;
      color: #003fa8 !important;
    }
    .twoTags {
      display: inline-block;
      cursor: pointer;
      padding: 8px 23px;
      line-height: 24px;
      text-align: center;
      border: 1px solid #888888;
      color: #3d3d3d;
      font-size: 16px;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .twoTagsTotal {
      color: #003fa8;
      font-size: 16px;
      line-height: 24px;
    }
    .threeTagsBox {
      width: calc(100% - 40px);
      padding: 0 20px;
      .threeTags {
        font-size: 16px;
        line-height: 24px;
        color: #3d3d3d;
        padding: 0 5px 8px;
        border-bottom: 2px solid #fff;
        margin-right: 25px;
        display: inline-block;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .threeIndex {
        border-bottom: 2px solid #003fa8;
        color: #003fa8;
        font-weight: 700;
      }
    }
  }
}
.jdTreeBox {
  // padding: 10px 37px;
  .jdTags {
    // width: 64px;
    padding: 0 15px;
    height: 40px;
    background: #f8f8f8;
    margin-right: 10px;
    margin-bottom: 10px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    color: #bbb;
    display: inline-block;
    // cursor: not-allowed;
    cursor: pointer;
  }
  .fgTagTrue {
    color: #003fa8;
    font-size: 16px;
    font-weight: bold;
    background: #fff;
    cursor: pointer;
  }
  .fgTagTrue2 {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    background: #003fa8;
    cursor: pointer;
  }
}
.zsgdListBox {
  background-color: #fff;
  margin-bottom: 20px;
  .zsgdList {
    width: calc(100% - 40px);
    padding: 20px 20px;
    background-color: #fff;
    border-bottom: 1px solid #d8d8d8;
    display: table;
    .zsgdListRight {
      width: calc(100% - 560px - 10px - 30px);
      padding: 10px 10px;
      background: #f5f5f5;
      display: table-cell;
      line-height: 24px;
      font-size: 14px;
      cursor: pointer;
      .zsgdRightTitle,
      .zsgdRightType,
      .zsgdRightDate {
        color: #003fa8;
        margin-bottom: 10px;
      }
    }
    .zsgdListLeft {
      width: 550px;
      padding-right: 10px;
      display: table-cell;
      .blueLabel {
        width: 120px;
        height: 30px;
        border-radius: 0px 15px 15px 0px;
        background: #003fa8;
        text-align: center;
        transform: translateX(0px);
        display: inline-block;
        span {
          font-size: 16px;
          font-weight: bold;
          line-height: 30px;
          color: #ffffff;
        }
      }
    }
  }
}

.el-empty {
  height: 500px;
  background: #fff;
}
::v-deep {
  .el-breadcrumb__item {
    font-size: 16px;
  }
}
::v-deep .list .content span p:first-child {
  display: inline;
}
::v-deep .list .content img {
  width: 100%;
}
::v-deep {
  .el-breadcrumb__item {
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 0 !important;
  }
  .el-breadcrumb__item:last-child {
    .el-breadcrumb__inner {
      color: #003fa8 !important;
    }
  }
  .el-breadcrumb__item:first-child {
    .el-breadcrumb__inner {
      color: #000 !important;
      font-weight: 700 !important;
    }
  }
}
.el-tree {
  background: none !important;
  box-sizing: content-box;
  overflow: auto;
  max-height: 800px;
}
::v-deep .el-tree > .el-tree-node {
  background: #eef8ff !important;
  margin: 5px 0;
}
::v-deep .el-tree > .el-tree-node:hover {
  background: #fff !important;
}
::v-deep .el-tree-node__content:hover {
  background: #fff !important;
}

::v-deep .el-tree > .el-tree-node > .el-tree-node__children {
  background: #fff !important;
  margin: 5px 0;
}
::v-deep .tree_container .el-tree-node {
  padding-left: 0;
}
// ::v-deep .el-tree > .el-tree-node > .el-tree-node__content:first-child .tOne{
//   background: #eef8ff;
//   margin: 5px 0;
// }
.el-tree {
  background: #ffffff !important;
}
// ::v-deep {
//   .el-tree-node {
//     /*设置横向滚动条*/
//     min-width: 100% !important;
//     display: block !important;
//     float: left;
//   }
// }

::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: none;
  .tOne {
    color: #003fa8 !important;
    font-weight: bold;
    // span {
    //   display: flex;
    //   flex-wrap: wrap;
    // }
  }
  // }
}
.el-breadcrumb {
  display: inline-block;
}
::v-deep .rightBox .el-breadcrumb__inner {
  font-weight: 700 !important;
  color: #000;
}

::v-deep .el-tree > .el-tree-node > .el-tree-node__content {
  height: 48px;
  line-height: 48px;
}
::v-deep .el-tree > .is-expanded {
  background: none !important;
}

::v-deep .el-tree > .is-expanded > .el-tree-node__content {
  background: #eef8ff !important;
}
.show-tree {
  width: 100%;
  overflow-x: hidden;
  ::v-deep .el-tree-node {
    width: 340px !important;
    white-space: normal; //关键代码!!!!!!!!!
    .el-tree-node__content {
      height: 100%;
      align-items: start;
    }
  }
}
::v-deep .pInline p:first-child {
  display: inline;
}
::v-deep .zsgdListLeft img {
  width: 100%;
}
.ddfglb {
  .source {
    font-size: 14px;
    font-weight: normal;
    line-height: 32px;
    letter-spacing: 0em;
    color: #003fa8;
    background: #f5f5f5;
    cursor: pointer;
  }
  .timeBox {
    color: #003fa8;
    background: #f5f5f5;
    font-size: 14px;
    line-height: 32px;
    .time {
      margin-left: 50px;
    }
  }
}







.el-tree .el-input__inner {
height: 58px !important;
line-height: 58px !important;
}

.el-button {
padding: 0;
}

// el-tree指示线样式
.tree_container ::v-deep{
.el-tree > .el-tree-node:after {
  border-top: none;
}

.el-tree-node {
  position: relative;
  /*padding-left: 16px;*/
}

//节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
.el-tree-node__expand-icon.is-leaf {
  display: none;
}

.el-tree-node__children {
  padding-left: 16px;
}

.el-tree-node :last-child:before {
  height: 38px;
}

.el-tree > .el-tree-node:before {
  border-left: none;
}

.el-tree > .el-tree-node:after {
  border-top: none;
}

.el-tree-node:before {
  content: '';
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.el-tree-node:after {
  content: '';
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.el-tree-node:before {
  border-left: 1px dashed #e6e6e6;
  bottom: 0px;
  height: 100%;
  top: -22px;
  width: 1px;
}

.el-tree-node:after {
  border-top: 1px dashed #e6e6e6;
  height: 20px;
  top: 16px;
  /*width: 24px;*/
  width:12px;
}

.el-tree-node__content {
  padding-left: 10px !important;
}
}

.el-table tr {
background-color: #f5f5f5;
}

.el-drawer__header > :first-child {
font-size: 22px;
color: #333;
}

.el-table th.el-table__cell > .cell {
color: #333;
font-size: 16px;
font-weight: 700;
}

.el-table td.el-table__cell {
border-bottom: none !important;
}

.el-table th.el-table__cell.is-leaf {
border-bottom: none !important;
}

.el-table::before {
content: '' !important;
background-color: #fff !important;
}















/***顶部的路径 start */
.topPathView{
  width: 1200px;
  min-height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
  border-radius: 0px 0px 0px 0px;
  box-sizing: border-box;
  padding:10px 20px;
  font-size: 16px;
  color: #3D3D3D;
  margin-bottom:10px;
  p{
      line-height: 30px;
  }
}
/***顶部的路径 end */
.showTreeName{
  width: 100%;
  height: 48px;
  line-height: 48px;
  background: #003FA8;
  box-sizing: border-box;
  padding-left:20px;
  font-size: 20px;
  color:#ffffff;
  margin-bottom:10px;
  .treeCount{
      font-size: 16px;
  }
}
.blueSpan{
  color:#003FA8!important;
}
</style>
